/* eslint-disable no-nested-ternary */
/* eslint-disable react/no-unused-prop-types */

import React, {
  useCallback,
  useEffect /* , { useCallback } */,
  useMemo,
  useState,
} from "react";
// import { useDispatch } from 'react-redux';
// import Model from "@tripian/model";
import { PreLoading, CloseIconButton } from "@tripian/react";

import IFavoritePoi from "../../../../models/IFavoritePoi";
// import { changeFavoritesVisible } from '../../../../../redux/action/layout';

import useFavorite from "../../../../hooks/useFavorite";
import useFocus from "../../../../hooks/useFocus";
import useTranslate from "../../../../hooks/useTranslate";
import classes from "./TimelineFavoritesContainer.module.scss";
import PoiCard from "../../../../components/PoiCard/PoiCard";
import Model from "@tripian/model";
import useTimelineStep from "../../../../hooks/useTimelineStep";
import { CloneModal } from "../../../../components/CloneModal/CloneModal";

interface PlanIdStepDay {
  planId: number;
  step: Model.Step;
  dayIndex: number;
}

interface ITimelineFavoritesContainer {
  show: boolean;
  dayIndex: number;
  tripHash: string;
  tripReadOnly: boolean;
  plans: Model.Plan[];
  isFocusOpen: boolean;
  gygTourIds: number[];
  bbTourIds: number[];
  viatorTourIds: string[];
  toristyTourIds: string[];
  toursLoading: boolean;
  onBookingClick: () => void;
  close: () => void;
}

const TimelineFavoritesContainer: React.FC<ITimelineFavoritesContainer> = ({
  show,
  dayIndex,
  tripHash,
  tripReadOnly,
  plans,
  isFocusOpen,
  gygTourIds,
  bbTourIds,
  viatorTourIds,
  toristyTourIds,
  toursLoading,
  onBookingClick,
  close /* , dayIndex */,
}) => {
  const [showCloneModal, setShowCloneModal] = useState<boolean>(false);
  const {
    cityId,
    favorites,
    favoriteAdd,
    favoriteDelete,
    loadingFavorites,
    loadingFavoritePoi /*, favoriteDelete */,
    favoritesFetch,
  } = useFavorite();
  const { timelineStepAdd, timelineStepDelete } = useTimelineStep();
  const { focusPoi } = useFocus();

  const { t } = useTranslate();

  const planStepDays: PlanIdStepDay[] = useMemo(() => {
    let steps: PlanIdStepDay[] = [];

    steps = plans.reduce(
      (
        previousValue: PlanIdStepDay[],
        currentValue: Model.Plan,
        currentIndex: number
      ) => {
        if (currentValue) {
          const currentSteps: PlanIdStepDay[] = currentValue.steps.map(
            step => ({
              planId: currentValue.id,
              step,
              dayIndex: currentIndex,
            })
          );

          return previousValue.concat(currentSteps);
        }

        return previousValue;
      },
      []
    );

    return steps;
  }, [plans]);

  const currentPlanId = useMemo(
    () => (dayIndex < plans.length ? plans[dayIndex].id : 0),
    [dayIndex, plans]
  );

  const poiPlanStepDay = useCallback(
    (poiId: string): PlanIdStepDay | undefined =>
      planStepDays.find(
        memoizedStep =>
          memoizedStep.step.poi.id === poiId &&
          memoizedStep.dayIndex === dayIndex
      ),
    [dayIndex, planStepDays]
  );

  const isCurrentDayStep = useCallback(
    (poiId: string): boolean => !!poiPlanStepDay(poiId),
    [poiPlanStepDay]
  );

  useEffect(() => {
    if (
      favorites === undefined &&
      loadingFavorites === false &&
      cityId !== undefined
    )
      favoritesFetch();
  }, [cityId, favorites, favoritesFetch, loadingFavorites]);

  const favoritesContainerClasses = [classes.favoritesContainer];
  if (!window.tconfig.SHOW_OVERVIEW)
    favoritesContainerClasses.push("container-height");
  else favoritesContainerClasses.push("container-height-tab");
  if (show) favoritesContainerClasses.push(classes.favoritesContainerOpen);
  else favoritesContainerClasses.push(classes.favoritesContainerClose);
  if (isFocusOpen) favoritesContainerClasses.push(classes.disabled);

  // Favorilerde olup olmadığını kontrol eden fonksiyon
  const isFavorite = (poiId: string) =>
    favorites
      ? favorites.findIndex(favorite => favorite.poiId === poiId) > -1
      : false;

  // Favorilere ekle/çıkar fonksiyonu
  const favoriteToggle = (poi: Model.Poi, add: boolean) => {
    if (add) {
      favoriteAdd(poi.id);
    } else {
      const favoriteId: number =
        favorites?.find(favorite => favorite.poiId === poi.id)?.id || 0;
      if (favoriteId) favoriteDelete(favoriteId, poi.id);
      else
        console.error(
          "favoriteToggle favorite delete error: Can not found poi id in favorite list",
          add,
          poi.id,
          favorites
        );
    }
  };

  const cardButtonOnClick = useCallback(
    (poi: Model.Poi, from?: string, to?: string) => {
      const planStepDay = poiPlanStepDay(poi.id);
      if (tripReadOnly) {
        setShowCloneModal(true);
      } else if (planStepDay) {
        timelineStepDelete(planStepDay.step.id);
      } else {
        timelineStepAdd(currentPlanId.toString(), poi.id, from, to);
      }
    },
    [currentPlanId, poiPlanStepDay, timelineStepAdd, timelineStepDelete, tripReadOnly]
  );

  const findDaysNumbers = (poiId: string): number[] | undefined => {
    if (poiId === "") return undefined;

    if (plans) {
      const partOfDayIndexes: number[] = [];
      for (let i = 0; i < plans.length; i += 1) {
        const stepIndex = plans[i].steps.findIndex(
          step => step.poi.id === poiId
        );
        if (stepIndex > -1) {
          // console.log('getPartOfDay dayNumber', stepIndex + 1);
          partOfDayIndexes.push(i + 1);
          // return i + 1;
        }
      }
      return partOfDayIndexes;
    }
    return undefined;
  };

  const renderContent = () => {
    if (loadingFavorites && favorites === undefined) return <PreLoading />;

    if (favorites) {
      if (favorites.length === 0)
        return (
          <div className="center mt-8">
            <span>
              {t("trips.myTrips.itinerary.favorites.emptyMessage")}
            </span>{" "}
          </div>
        );

      return favorites.map((favoritePoi: IFavoritePoi) =>
        loadingFavoritePoi(favoritePoi.poiId) ? (
          <div
            key={`favorite-loading-${favoritePoi.id}`}
            className={classes.favoriteItemsLoading}
          >
            <PreLoading size="small" />
          </div>
        ) : (
          // <PoiRefCard
          //   key={`favorite-poi-ref-card-${favoritePoi.id}`}
          //   poi={favoritePoi.poi}
          //   poiCardClicked={(p) => {
          //     focusPoi(p);
          //   }}
          //   hideReservationIcon={!window.tconfig.SHOW_RESTAURANT_RESERVATIONS}
          //   hideTourTicketIcons={!window.tconfig.SHOW_TOURS_AND_TICKETS}
          //   hideOfferIcon={!window.tconfig.SHOW_OFFERS}
          //   TOUR_PROVIDER_IDS={window.tconfig.TOUR_TICKET_PROVIDER_IDS}
          //   TICKET_PROVIDER_IDS={window.tconfig.TOUR_TICKET_PROVIDER_IDS}
          //   RESTAURANT_RESERVATION_PROVIDER_IDS={window.tconfig.RESTAURANT_RESERVATION_PROVIDER_IDS}
          //   gygTourIds={gygTourIds}
          //   bbTourIds={bbTourIds}
          //   viatorTourIds={viatorTourIds}
          //   toristyTourIds={toristyTourIds}
          //   tourTicketProductsLoading={toursLoading}
          //   t={t}
          // />

          <PoiCard
            key={`favorite-poi-ref-card-${favoritePoi.id}`}
            poi={favoritePoi.poi}
            inStep={isCurrentDayStep(favoritePoi.poi.id)}
            isFavorite={isFavorite(favoritePoi.poi.id)}
            isLoadingFavorite={loadingFavoritePoi(favoritePoi.poi.id)}
            dayNumbers={findDaysNumbers(favoritePoi.poi.id)}
            TOUR_PROVIDER_IDS={window.tconfig.TOUR_TICKET_PROVIDER_IDS}
            TICKET_PROVIDER_IDS={window.tconfig.TOUR_TICKET_PROVIDER_IDS}
            RESTAURANT_RESERVATION_PROVIDER_IDS={
              window.tconfig.RESTAURANT_RESERVATION_PROVIDER_IDS
            }
            hideTourTicketIcons={!window.tconfig.SHOW_TOURS_AND_TICKETS}
            gygTourIds={gygTourIds}
            bbTourIds={bbTourIds}
            viatorTourIds={viatorTourIds}
            toristyTourIds={toristyTourIds}
            tourTicketProductsLoading={toursLoading}
            poiCardClicked={focusPoi}
            onAddPoiClick={cardButtonOnClick}
            onFavoriteToggle={favoriteToggle}
            onBookingClick={() => {
              focusPoi(favoritePoi.poi);
              onBookingClick();
            }}
            t={t}
          />
        )
      );
    }

    return null;
  };

  return (
    <div className={favoritesContainerClasses.join(" ")}>
      <div className="sticky top-0 bg-white z-10 flex items-center justify-between px-8 mt-6 pb-6 mb-1 border-b border-[#D5D5D5]">
        <h3 className="font-medium text-xl">
          {t("trips.myTrips.itinerary.favorites.title")}
        </h3>
        <div className={`${classes.favoritesCloseIcon}`}>
          <CloseIconButton fill="#000" clicked={close} />
        </div>
      </div>
      <div className="scrollable-y" style={{ height: "calc(100% - 80px)" }}>
        <div className="px8 mt5">{renderContent()}</div>
      </div>
      {showCloneModal && (
        <CloneModal
          sharedTripHash={tripHash ?? ""}
          onCancel={() => setShowCloneModal(false)}
        />
      )}
    </div>
  );
};

export default TimelineFavoritesContainer;
